<section class="hero-section">
  <!-- Background Pattern -->
  <div class="background-pattern"></div>
  
  <div class="container">
    <div class="hero-content-wrapper">
      <div class="hero-content">
        <h1>Have a message?</h1>
        <p>Let your supporters help you share it.</p>
      </div>
    </div>
  </div>
  
  <!-- Bottom Wave SVG -->
  <div class="wave-container">
    <div class="wave-svg">
      <svg width="3774" height="201" viewBox="0 0 3774 201" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 200.003C0 200.003 1137.52 0.188224 1873.5 0.000134392C2614.84 -0.189325 3774 200.003 3774 200.003H0Z" fill="white"/>
      </svg>
    </div>
  </div>
</section>
